<template>
  <div
    v-if="notesOpen"
    class="notes-canvas-wide"
  >
    <h3 class="notes-canvas-wide__page-heading">
      {{ draftType === 'board'
        ? $t('Page %(idx)s', { idx: pageIndex + 1 })
        : $t('Slide %(idx)s', { idx: pageIndex + 1 }) }}
    </h3>
    <ModuleWrapper
      v-for="note in notes"
      :key="note.moduleData.id"
      mode="VIEW"
      :module-data="note.moduleData"
      canvas-name="notes"
      :scale="1"
      :id="note.moduleData.id"
      :style="note.formattedStyle"
      class="notes-canvas-wide__module"
    >
      <component
        :is="moduleTypeToComponent(note.moduleData.type)"
        :id="note.moduleData.id"
        mode="VIEW"
        :module-data="note.moduleData"
        :scale="1"
        canvas-name="notes"
        :size-to-parent="false"
        :page="page"
      />
    </ModuleWrapper>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import chain from '@/lib/utils/chain';
import { moduleTypeToComponent } from '@/lib/utils';
import { heightToPixels } from '@/lib/utils/grid';
import ModuleWrapper from '@/components/ModuleWrapper.vue';
import modules from '@/components/modules/index';
import {
  useEditorStore,
} from '@/stores';

export default {
  name: 'FullscreenNotesWide',
  components: {
    ModuleWrapper,
    ...modules,
  },
  props: {
    page: {
      type: Object,
      required: true,
    },
    pageIndex: {
      type: Number,
      required: true,
    },
    notesOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(useEditorStore, [
      'draftType',
    ]),
    notes() {
      return chain(this.page.notes)
        .sortBy((mod) => mod.layout.y_position)
        .map((mod) => this.addFormattedModuleStyle(mod))
        .value();
    },
  },
  methods: {
    moduleTypeToComponent,
    addFormattedModuleStyle(mod) {
      const usePixelHeight = [
        'button',
        'advanced_button',
        'placeholder',
      ].includes(mod.type)
      || (['asset', 'upload'].includes(mod.type) && mod.options?.layout !== 'top')
      || mod.options?.shape;

      return {
        moduleData: mod,
        formattedStyle: usePixelHeight ? {
          height: `${heightToPixels(mod.layout.height)}px`,
        } : {},
      };
    },
  },
};
</script>

<style lang="stylus">
.notes-canvas-wide {
  padding: $nebula-space-4x;

  &__page-heading {
    nebula-text-body-2();

    color: $nebula-color-platform-interactive-800;
    margin: 0 0 $nebula-space-2x;
  }

  &__module:not(:last-child) {
    margin-bottom: $nebula-space-2x;
  }
}
</style>
